import * as React from 'react';
import { Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import { Translate } from '../../../../shared/LanguageService';

export const PhotographerFormComponentPortfolio = (props: any) => {
    let { labels } = props;

    return (
        <fieldset>
            <legend>{labels.legend}</legend>
            <Row>
                <Col xs={10} >
                    <FormGroup controlId="photographerDescription">
                        <ControlLabel>
                            {labels.description}
                        </ControlLabel>
                        <FormControl
                            componentClass="textarea"
                            className='text-area-roomy'
                            name="description"
                            value={props.user && props.user.description ? props.user.description : ''}
                            onChange={props.onChange}
                        />
                    </FormGroup>

                    <Row>
                        <Col sm={5}>
                            <FormGroup controlId="photographerInstagram" className='photographerInstagram'>
                                <ControlLabel>
                                    {labels.instagram}
                                </ControlLabel>
                                <div style={{ position: 'relative' }}>
                                    <span style={{ position: 'absolute', width: '26px', paddingLeft: '12px', lineHeight: '36px' }}>@</span>
                                    <FormControl
                                        style={{ paddingLeft: '26px' }}
                                        type="text"
                                        name="instagramLink"
                                        value={props.user && props.user.instagramLink ? props.user.instagramLink : ''}
                                        onChange={props.onChange}
                                    />
                                </div>
                            </FormGroup>

                        </Col>
                    </Row>

                </Col>
            </Row>
        </fieldset >
    )
}

function TranslatedPhotographerFormComponentPortfolio(props: any) {
    const labels: any = {
        legend: Translate('photographers/modal/form/legend/portfolio'),
        description: Translate('photographers/modal/form/input-label/description'),
        instagram: Translate('photographers/modal/form/input-label/instagram')
    };

    return <PhotographerFormComponentPortfolio {...props} labels={labels} />;
}

export default TranslatedPhotographerFormComponentPortfolio
